<template>
  <button
    id="taskbar-item"
    :class="{ windowVisible }"
    :style="{ 'background-image': `url(${iconSrc})` }"
    @click="onClick"
  ></button>
</template>

<script>
import windowStateStore, {
  onTaskBarItemClick,
} from "@/stores/WindowStateStore";

export default {
  name: "TaskBarItem",
  props: {
    iconSrc: String,
    windowName: String,
  },
  computed: {
    windowVisible() {
      return windowStateStore.visibleWindows.includes(this.windowName);
    },
  },
  methods: {
    onClick() {
      onTaskBarItemClick(this.windowName);
    },
  },
};
</script>

<style scoped lang="scss">
#taskbar-item {
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  border: none;
  width: 50px;
  height: 50px;
  cursor: pointer;
  vertical-align: middle;
  opacity: 1;
  padding: 0;
  margin: 0;

  transition-property: opacity, transform;
  transition-duration: 70ms;
  transition-timing-function: ease-in-out;
  transform-origin: bottom;

  &:hover {
    transform: scale(1.3);
  }

  &:active {
    opacity: 0.7;
  }

  &.windowVisible::after {
    display: block;
    content: "";

    padding-top: 53px;
    border-bottom: 3px solid white;
    width: 10px;
    margin: 0 auto;
  }
}
</style>
